import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "entity-fields" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("dl", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, (field) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: field.name
      }, [
        (field.name != 'name')
          ? (_openBlock(), _createElementBlock("dt", _hoisted_2, _toDisplayString(field.label), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (field.name != 'name')
          ? (_openBlock(), _createElementBlock("dd", _hoisted_3, _toDisplayString($props.entity[field.name] || ''), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}